import { initOtel } from "./initOtel";

initOtel();
